module dg.actions {

    export class CommandExecutedChannelService {

        public constructor(
            private $rootScope: any
        ) { }

        private readonly ITEM_SAVED = 'ITEM_SAVED';

        public commandExecuted = (command: dg.domain.commands.CommandBase) => {
            this.$rootScope.$broadcast(this.ITEM_SAVED, command);
        }

        public onCommandExecuted = ($scope: ng.IScope, handler: (c: dg.domain.commands.CommandBase) => any) => {
            return $scope.$on(this.ITEM_SAVED, (event, command) => {
                handler(command);
            });
        }
        
    }

    angular.module('dg.actions')
        .service('commandExecutedChannelService', CommandExecutedChannelService);
}

